import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { agentInfo } from '../mockData';

export const About = () => {
  return (
    <section id="about" className="py-20 md:py-32 bg-stone-50" data-testid="about-section">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          {/* Photo Side */}
          <div className="relative max-w-sm mx-auto lg:max-w-none lg:mx-0" data-testid="about-photo-wrapper">
            <div className="aspect-[4/5] overflow-hidden bg-stone-200">
              <img
                src={agentInfo.photo}
                alt={agentInfo.name}
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-6 bg-white px-4 py-3 md:px-6 md:py-4 shadow-sm flex items-center gap-3">
              <img
                src="https://customer-assets.emergentagent.com/job_imoveis-faro-pt/artifacts/pvj0xi3c_bala%CC%83o%20SEM%20SOMBRA%20%281%29.png"
                alt="RE/MAX Platina"
                className="h-8 md:h-10 w-auto"
                data-testid="remax-balloon-about"
              />
              <div>
                <div className="text-[10px] md:text-xs text-stone-500 tracking-wider uppercase">RE/MAX Platina</div>
                <div className="text-xs md:text-sm font-medium text-stone-900 mt-0.5 md:mt-1">Portimão · Algarve</div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <span className="text-xs tracking-[0.2em] uppercase text-stone-500 font-medium" data-testid="about-label">
              Sobre
            </span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-stone-900 mt-4 mb-8 leading-tight" data-testid="about-title">
              <span className="font-light text-stone-600">Olá, sou o </span>
              <span className="block italic font-serif text-stone-900 uppercase tracking-tight mt-2">Rustem.</span>
            </h2>

            <div className="space-y-6 text-stone-600 font-light leading-relaxed">
              <p data-testid="about-description-1">
                Trabalho na <span className="italic font-serif text-stone-900">RE/MAX Platina</span> em Portimão — uma agência com <span className="italic font-serif text-stone-900">10 anos de história</span> no mercado do Algarve, que já ajudou <span className="italic font-serif text-stone-900">milhares de clientes</span> a encontrar o imóvel perfeito ou a vender com o melhor acompanhamento.
              </p>
              <p data-testid="about-description-2">
                O meu compromisso é simples: <span className="italic font-serif text-stone-900">ouvir</span>, aconselhar com transparência, e estar presente em cada etapa do processo. Quer compre ou venda, vamos transformar o seu sonho numa morada.
              </p>
            </div>

            {/* Contact Lines */}
            <div className="mt-12 space-y-4 border-t border-stone-200 pt-8" data-testid="about-contact">
              <a
                href={`tel:${agentInfo.phone}`}
                className="flex items-center gap-4 text-stone-700 hover:text-stone-900 transition-colors group"
                data-testid="contact-phone"
              >
                <Phone className="w-4 h-4 text-stone-400 group-hover:text-stone-900 transition-colors" strokeWidth={1.5} />
                <span className="text-sm">{agentInfo.phone}</span>
              </a>
              <a
                href={`mailto:${agentInfo.email}`}
                className="flex items-center gap-4 text-stone-700 hover:text-stone-900 transition-colors group"
                data-testid="contact-email"
              >
                <Mail className="w-4 h-4 text-stone-400 group-hover:text-stone-900 transition-colors" strokeWidth={1.5} />
                <span className="text-sm">{agentInfo.email}</span>
              </a>
              <div className="flex items-center gap-4 text-stone-700" data-testid="contact-location">
                <MapPin className="w-4 h-4 text-stone-400" strokeWidth={1.5} />
                <span className="text-sm">{agentInfo.location}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
